module.exports = __webpack_public_path__ + "img/events-normal.95fc4288.svg";